import { de } from './de';
import { en } from './en';

export { de, en };
export default { de, en };
